module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"btn-close\">&#x2716;</div>\n<div class=\"popup-inner\">\n    <div class=\"success-area\">\n        <h3>Product has been purchased</h3>\n        <p>You can visit the <a href=\"";
  if (stack1 = helpers.productURL) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.productURL; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\">store</a> to see your product cart.</p>\n    </div>\n    <div class=\"form-area\">";
  if (stack1 = helpers.content) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.content; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n</div>\n";
  return buffer;
  });